module.exports = __webpack_public_path__ + "static/piano-a4d41e1db1a284462e41a76320040510.jpg";